export enum Queries {
    getInsightData = 'getInsightData',
    getSolutionGoalCardOptions = 'getSolutionGoalCardOptions',
}
